// @flow
import * as React from "react";

import AuthService from "services/auth";

import Actions from "./Actions";
import ThemeToggle from "./Actions/ThemeToggle";
import Navigation from "./Navigation";

const Navbar = {
  LoggedIn(): React.Node {
    const claims = AuthService.getClaims();

    return (
      <>
        <ul className="navbar-nav nav-pills">
          <Navigation claims={claims} />
        </ul>
        <Actions claims={claims} />
      </>
    );
  },
  LoggedOut(): React.Node {
    return (
      <ul className="navbar-nav ms-auto align-items-center">
        <ThemeToggle />

        <li className="nav-item">
          <div className="d-flex align-items-center gap-2">
            <a href="/login" className="btn btn-sm btn-outline-secondary">
              Log in
            </a>
            <a href="/signup" className="btn btn-sm btn-primary">
              Sign up
            </a>
          </div>
        </li>
      </ul>
    );
  },
};

export default Navbar;
